import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DatesService {

    private route = inject(ActivatedRoute);
    today = new Date().toLocaleDateString('en-CA');

    private datesRaw = toSignal(
        this.route.queryParamMap.pipe(map((p) => p.get("dates") ?? this.today)),
        { initialValue: this.today }
    );


    isPartialDate = toSignal(
        this.route.queryParamMap.pipe(
            map((p) => {
                const val = p.get("isPartialDate");
                if (val === null) return true;
                return val === 'true';
            })
        ),
        { initialValue: true }
    );


    datesArray = computed(() => {
        const raw = this.datesRaw();
        return raw ? raw.split(',') : [this.today];
    });

    datesAsObjects = computed(() => {
        return this.datesArray().map(d => {
            const [year, month, day] = d.split('-').map(Number);
            return new Date(year, month - 1, day);
        });
    });





}
